import i18n from '@/i18n'
import { ExtendedColumnSort } from '@/types/data-table'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'

export type ApiError = AxiosError<{
  code?: string
  errors?: unknown[]
  error?: string
  message?: string
  remaining_seconds?: number
}>

export function resolveErrorMessageFrom(error: ApiError) {
  if (error.response == null) {
    return i18n.t('error_toast.title')
  }

  if (error.response.status === 419) {
    return i18n.t('error.csrf_reload_required')
  }

  if (error.response.status === 429) {
    return i18n.t('error.too_many_requests')
  }

  const data = error.response.data
  if (data.message != null) {
    return data.message
  }

  if (data.error != null) {
    return data.error
  }

  const errors = data.errors
  if (errors && errors.length > 0) {
    return Object.entries(errors)
      .map(([, val]) => val)
      .join('\n')
  }

  return i18n.t('error_toast.title')
}

export const restApiErrorHandler = (error: ApiError & Error) => {
  toast.error(resolveErrorMessageFrom(error), { position: 'bottom-center' })
}

export const sortParser = <TData>(sorting: ExtendedColumnSort<TData>[]) => {
  return sorting.length > 0
    ? `${sorting[0].desc ? '-' : ''}${sorting[0].id as string}`
    : undefined
}
